module.exports = {"360102001":"公园街道","360102002":"滕王阁街道","360102003":"八一桥街道","360102004":"百花洲街道","360102005":"墩子塘街道","360102006":"大院街道","360102007":"豫章街道","360102008":"董家窑街道","360102009":"彭家桥街道","360102050":"沙井街道（红谷滩新区）","360102100":"扬子洲镇","360102400":"贤士湖管理处","360102401":"扬农管理处","360102450":"凤凰洲管理处（红谷滩新区）"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360102.json
// module id = 1149
// module chunks = 0